import { z } from 'zod';

import i18n from '@/i18n';

export const EmailSchema = z.object({
    email: z.string().email(i18n.global.t('Vinaliga skriva ein rættan teldubústað.')),
});
